// @flow
import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { getTranslate } from "react-localize-redux";

type PropsType = {
  translate: string => void
};

type StateType = {};

class HrSolutionsPageContainer extends Component<PropsType, StateType> {
  render() {
    const { translate } = this.props;
    return (
      <div>
        <header class="header text-white" style={{ backgroundColor: "#2d2d2d" }}>
          <div class="container text-center">
            <div class="row">
              <div class="col-md-8 mx-auto">
                <h1>{translate("HrSolutionsPageLocale.header")}</h1>
                <p className="lead-2 opacity-90 mt-6">{translate("HrSolutionsPageLocale.header_secondary")}</p>
              </div>
            </div>
          </div>
        </header>
        <div className="col-md-8 mx-auto">
          <p className="lead-2 opacity-90 mt-6">
            {translate("HrSolutionsPageLocale.content.services.description")}
          </p>

          <ul>
            <li className="lead">
              {translate("HrSolutionsPageLocale.content.services.items.one.content")}
              <ul>
                <li className="lead">
                  {translate("HrSolutionsPageLocale.content.services.items.one.items.one_one")}
                </li>
                <li className="lead">
                  {translate("HrSolutionsPageLocale.content.services.items.one.items.one_two")}
                </li>
              </ul>
            </li>

            <li className="lead">
              {translate("HrSolutionsPageLocale.content.services.items.two.content")}
              <ul>
                <li className="lead">
                  {translate("HrSolutionsPageLocale.content.services.items.two.items.two_one")}
                </li>
                <li className="lead">
                  {translate("HrSolutionsPageLocale.content.services.items.two.items.two_two")}
                </li>
              </ul>
            </li>

            <li className="lead">
              {translate("HrSolutionsPageLocale.content.services.items.three.content")}
              <ul>
                <li className="lead">
                  {translate("HrSolutionsPageLocale.content.services.items.three.items.three_one")}
                </li>
                <li className="lead">
                  {translate("HrSolutionsPageLocale.content.services.items.three.items.three_two")}
                </li>
              </ul>
            </li>

            <li className="lead">
              {translate("HrSolutionsPageLocale.content.services.items.four.content")}
              <ul>
                <li className="lead">
                  {translate("HrSolutionsPageLocale.content.services.items.four.items.four_one")}
                </li>
                <li className="lead">
                  {translate("HrSolutionsPageLocale.content.services.items.four.items.four_two")}
                </li>
              </ul>
            </li>

            <li className="lead">
              {translate("HrSolutionsPageLocale.content.services.items.five.content")}
              <ul>
                <li className="lead">
                  {translate("HrSolutionsPageLocale.content.services.items.five.items.five_one")}
                </li>
                <li className="lead">
                  {translate("HrSolutionsPageLocale.content.services.items.five.items.five_two")}
                </li>
              </ul>
            </li>
          </ul>

          <p className="lead">
            {translate("HrSolutionsPageLocale.content.contact")}
          </p>
          <div className="text-center m-9">
            <Link to="/" className="btn btn-primary btn-round btn-label">
              <label>
                <i className="fas fa-arrow-circle-left"/>
              </label>
              {translate("GlobalLocale.return_to_homepage")}
            </Link>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    translate: getTranslate(state.locale)
  };
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      // load actions here
    },
    dispatch
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(HrSolutionsPageContainer);



// WEBPACK FOOTER //
// ./src/Containers/PublicPages/HrSolutionsPageContainer.js